import { authService } from "@mr-portfolio-infrastructure/auth/auth-service";
import { createPricesHubConnection } from "@mr-portfolio-infrastructure/live-updates/prices-hub-connection";

import { AuthStore } from "./auth-store";
import { LiveUpdatesStore } from "./live-updates-store";
import { NotificationStore } from "./notification-store";
import { PortfoliosStore } from "./portfolios-store";
import { SettingsStore } from "./settings-store";

/** Application-wide state only. Screen state lives in feature stores next to the screen. */
export class RootStore {
  public readonly authStore: AuthStore;
  public readonly settingsStore: SettingsStore;
  public readonly notificationStore: NotificationStore;
  public readonly portfoliosStore: PortfoliosStore;
  public readonly liveUpdatesStore: LiveUpdatesStore;

  public constructor() {
    this.authStore = new AuthStore(authService);
    this.settingsStore = new SettingsStore();
    this.notificationStore = new NotificationStore();
    this.portfoliosStore = new PortfoliosStore();
    this.liveUpdatesStore = new LiveUpdatesStore(createPricesHubConnection);
  }
}
